// extracted by mini-css-extract-plugin
module.exports = {"renameIcon":"TagsModalContent-renameIcon-3oaI2","message":"TagsModalContent-message-X9IX-","result":"TagsModalContent-result-2eiBF"};